import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

export default {
    name: 'TotalUsersCount',
    responseFormat: 'rows',
    productArea: PRODUCT_AREAS.METADATA,
    subProductArea: SUB_PRODUCT_AREAS.METADATA,
    build: ({ aggSourceName, additionalSourceCriteria = {} }) => {
        const pipeline = o.pipeline(
            o.sources[aggSourceName]({ blacklist: 'apply', ...additionalSourceCriteria }),
            o.select({ id: 'id' }),
            o.count(null),
        );

        return pipeline;
    },
};
